import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';

/**
 * A component to manage SEO helmet metadata for articles pagination
 * This determines if a next page exists by checking DOM elements
 */
const ArticlesHelmet = ({ currentPage }) => {
  const [hasNextPage, setHasNextPage] = useState(false);

  useEffect(() => {
    // Check if next button is disabled to determine if there's a next page
    const checkNextPageExists = () => {
      const nextButton = document.querySelector('button[aria-label="Next page"]') ||
                         Array.from(document.querySelectorAll('button'))
                           .find(btn => btn.textContent.includes('Next'));
      
      if (nextButton) {
        setHasNextPage(!nextButton.disabled);
      } else {
        // If we can't find the button, check total pages from text content
        const paginationText = document.querySelector('.pagination-info');
        if (paginationText) {
          const text = paginationText.textContent;
          const matches = text.match(/Page (\d+) of (\d+)/);
          
          if (matches && matches.length === 3) {
            const current = parseInt(matches[1], 10);
            const total = parseInt(matches[2], 10);
            setHasNextPage(current < total);
          }
        } else {
          // If we can't determine, assume there might be a next page
          // This is a reasonable fallback - search engines will just check the next page
          setHasNextPage(true);
        }
      }
    };

    // Wait for the pagination UI to render
    setTimeout(checkNextPageExists, 1000);
  }, [currentPage]);

  return (
    <Helmet>
      {/* Add next link if there are more pages */}
      {hasNextPage && (
        <link 
          rel="next" 
          href={`${window.location.origin}/a/?page=${currentPage + 1}`} 
        />
      )}
    </Helmet>
  );
};

export default ArticlesHelmet;